import React, { useState, useCallback, useEffect, Fragment } from "react";
import gql from "graphql-tag";
import { useMutation } from "@apollo/react-hooks";
import styled from 'styled-components';
import NavigationBar from './NavigationBar';
import Jumbotron from './Jumbotron';
import LoadingOverlay from 'react-loading-overlay';
import {
    Form,
    InputNumber,
    Checkbox, Col, Row, DatePicker, Button
  } from 'antd';
import 'antd/dist/antd.css';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import CheckBoxGrid from './CheckBoxGrid';

const Styles = styled.div`
    .ant-checkbox-group  {
        width: 100%;
    }
    .ant-btn-primary {
        background-color: orange;
    }
`;
const mutation = gql`
  mutation virtualExport {
    virtualExport {
        fname
        lname
        email
        amount
    }
  }
`;
const VirtualCardReport = (props) => {
    const [spinnerDisplay, setSpinnerDisplay] = useState(false);
    const formItemLayout = {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 24,
        },
      };
    const colLabels = {'fname': 'First Name','lname': 'Last Name', 'email': 'Email Address', 'amount': 'Amount'};
    /*const headerOrder = {'attentionTo': 'Name', 'fullName': 'Company', 'email':'Email', 'phone': 'Phone', 'mobile': 'Mobile', 'fax': 'Fax', 'memo': 'Website'
                        ,'address1' : 'Street', 'city': 'City', 'state':'State', 'zip':'Zip', 'country': 'Country', 'amount': 'Opening Balance', 'checkDate': 'Date', 'taxId': 'Tax ID'};
    const blankFields = ['mobile', 'fax', 'taxId', 'country'];*/
    
    let [pullData, {loading, data}] = useMutation(mutation);
    const fileName = "VirtualCardReport";
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    
    const onFinish = values => {
        //console.log(columns);
        //console.log(reportDates);
        setSpinnerDisplay(true);
        pullData().then(
            res => {
                setSpinnerDisplay(false);
                console.log(res);
                let tempRowData = [];
                
                res.data.virtualExport.map( paymentEntry => {
                    let payment = {};
                    const keys = Object.keys(paymentEntry);
                    const addressFields = ['address1', 'city', 'state', 'zip'];
                    //console.log(reportCols);
                    keys.map(colKey => {
                        if (colKey !== 'address' && colKey !== '__typename') {
                            payment[colLabels[colKey]] = paymentEntry[colKey];
                        } else if (colKey === 'address') {
                            addressFields.map(akey => {
                                paymentEntry.address[akey] = (akey === 'address1') ? paymentEntry.address['address1']+' '+paymentEntry.address['address2'] : paymentEntry.address[akey];
                                payment[colLabels[akey]] = paymentEntry.address[akey];
                            });
                        }
                    })
                    
                    //console.log(payment);
                    tempRowData.push(payment);
                });
                const columnOrder = [];
        
                for (let key in colLabels) {
                    //console.log(key,':',headerOrder[key]);
                    columnOrder.push(colLabels[key]);
                }
                const ws = XLSX.utils.json_to_sheet(tempRowData, {header:columnOrder});
                const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const data2 = new Blob([excelBuffer], {type: fileType});
                FileSaver.saveAs(data2, fileName + fileExtension);
            },
            err => {console.log(err); }
            );
    };
    
    return (
        <Fragment>
            <LoadingOverlay
                active={spinnerDisplay}
                spinner
                text='Loading your report data...'
                >
            <NavigationBar />
            <Jumbotron />
                <br />
            <Styles>
                
                
            <main>
                <div className="container">
	                <h2>Virtual Card Report</h2>	          
                    <p>Reports will be produced and downloaded as Excel</p>
                    <Form
                        name="report"
                        {...formItemLayout}
                        onFinish={onFinish}
                        >
                    <div className="card">
                        <div className="card-body">
                            <Row>
                                <Col span={6} offset={10}>
                                <Button type="primary" htmlType="submit" shape="round" size="large">
                                    Export Report
                                </Button>
                                </Col> 
                            </Row>

                            
                        </div>
                    </div>
                    </Form>
                </div>
                <br />
                
            </main>
            </Styles>
            </LoadingOverlay>
            
        </Fragment>
    );
}

export default VirtualCardReport;